import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseLargeBadgePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.5 1A6.5 6.5 0 0 1 23 7.5h.01c0 1.27-.38 2.46-1.01 3.46V18c0 1.1-.9 2-2 2 0 .55-.45 1-1 1s-1-.45-1-1H6c0 .55-.45 1-1 1s-1-.45-1-1c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h3.5V5c0-1.1.9-2 2-2h2.32C13 1.77 14.66 1 16.5 1ZM4 18h2V8H4v10ZM21 7.5C21 5.01 18.99 3 16.5 3S12 5.01 12 7.5s2.01 4.5 4.5 4.5S21 9.99 21 7.5ZM10.5 5h-1v1h.68c.08-.34.19-.68.32-1ZM8 8v10h8v-4.03A6.478 6.478 0 0 1 10.03 8H8Zm10 5.82V18h2v-5.03c-.61.39-1.28.68-2 .85ZM15.5 8.5H14c-.55 0-1-.45-1-1s.45-1 1-1h1.5V5c0-.55.45-1 1-1s1 .45 1 1v1.5H19c.55 0 1 .45 1 1s-.45 1-1 1h-1.5V10c0 .55-.45 1-1 1s-1-.45-1-1V8.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcaseLargeBadgePlus;
